import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AbcAnalysisByEnum } from '@zaoblako/shared/modules/document/enums/abc-analysis-by.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link AbcAnalysisByEnum} enumeration values */
export const AbcAnalysisByEnumI18n: EnumI18nInterface<AbcAnalysisByEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AbcAnalysisByEnum.BY_DATE]: 'Дата',
    [AbcAnalysisByEnum.BY_CREATOR]: 'Автор',
    [AbcAnalysisByEnum.BY_COMPANY]: 'Компания',
    [AbcAnalysisByEnum.BY_CONTRAGENT]: 'Контрагент',
    [AbcAnalysisByEnum.BY_DOCUMENT_TYPE]: 'Тип документа',
    [AbcAnalysisByEnum.BY_OPERATION_TYPE]: 'Вид операции',
    [AbcAnalysisByEnum.BY_FILIAL]: 'Филиал',
    [AbcAnalysisByEnum.BY_DIRECTION]: 'Бюджетная статья',
    [AbcAnalysisByEnum.BY_UNIT]: 'Бизнес единица',
    [AbcAnalysisByEnum.BY_DEAL]: 'Сделка',
    [AbcAnalysisByEnum.BY_CONTRACT]: 'Договор',
    [AbcAnalysisByEnum.BY_COST_CENTER]: 'Центр затрат',
  },
  [I18nLocalesEnum.EN_US]: {
    [AbcAnalysisByEnum.BY_DATE]: 'Date',
    [AbcAnalysisByEnum.BY_CREATOR]: 'Creator',
    [AbcAnalysisByEnum.BY_COMPANY]: 'Company',
    [AbcAnalysisByEnum.BY_CONTRAGENT]: 'Counterparty',
    [AbcAnalysisByEnum.BY_DOCUMENT_TYPE]: 'Document Type',
    [AbcAnalysisByEnum.BY_OPERATION_TYPE]: 'Operation Type',
    [AbcAnalysisByEnum.BY_FILIAL]: 'Filial',
    [AbcAnalysisByEnum.BY_DIRECTION]: 'Direction',
    [AbcAnalysisByEnum.BY_UNIT]: 'Unit',
    [AbcAnalysisByEnum.BY_DEAL]: 'Deal',
    [AbcAnalysisByEnum.BY_CONTRACT]: 'Contract',
    [AbcAnalysisByEnum.BY_COST_CENTER]: 'Cost Center',
  },
};
